import React, { useState, useEffect, useContext } from "react";
import { ReferenciaCabecera } from "../../../interfaces/ReferenciaCabecera";
import { documentToReactComponents } from "@contentful/rich-text-react-renderer";
import Button from "../../atoms/button/button";
import useBrowserMode from "../../../shared/hooks/useBrowserMode";
import useScrollDetect from "../../../shared/hooks/useScrollDetect";
import "./headboardSalaPrensa.scss";
import { isMobile, isMobileHelper } from "../../../utils/helpers";
import GlobalContext from "../../../contexts/globalContext";
import ModalSolicitudServicios from "../../molecules/modal-solicitud-servicios/modalSolicitudServicios";
import Breadcrumb from "../../atoms/breadcrumb/breadcrumb";
import useElementSize from "../../../hooks/useElementSize";

const HeadboardSalaPrensa = (props: ReferenciaCabecera) => {
    const { window, document } = useBrowserMode();
    const {  refElement } = useScrollDetect();
    const url = new URL(window.location.href);
    const [showProtect, setShowProtect] = useState(true);
    const [doRedirect, setDoRedirect] = useState(false);
    const [isOpenModal, setIsOpenModal] = useState<boolean>(false);
    const [isImageMobile, setImageIsMobile] = useState(isMobileHelper());
    const ulMenu: any = document.querySelector(".o-headboard-sala-prensa__tabs.mobile");
    const headerSize = useElementSize(".m-header");

    const moveUlMenu = (direction: string) => {
        const chevronLeft: any = document.querySelector(".o-headboard-sala-prensa__arrow.icon-chevron-left");
        const chevronRight: any = document.querySelector(".o-headboard-sala-prensa__arrow.icon-chevron-right");

        if (direction == "R") {
            ulMenu.scrollLeft += 200;
        }
        else {
            ulMenu.scrollLeft -= 200;
        }

        ulMenu.scrollLeft > 0 ? chevronLeft.classList.add("active") : chevronLeft.classList.remove("active");
        ulMenu.scrollLeft > 400 ? chevronRight.classList.remove("active") : chevronRight.classList.add("active");
    };


    useEffect(() => {
        window.scrollTo(0, 0);
      }, []);

    const Context = useContext(GlobalContext);

    const handlePopup = () => {
        setShowProtect(false);
        sessionStorage.setItem("popup", "off");
    };

    useEffect(() => {
        if (Context.gigyaContext.gigyaAccount && doRedirect) redirect();
    }, [Context.gigyaContext.gigyaAccount]);

    const handleIngresaAction = async () => {
        if (Context.gigyaContext.gigyaAccount) {
            redirect();
        } else {
            Context.gigyaContext.loginComfamaId!();
            setDoRedirect(true);
        }
    };

    const closeModal = () => {
		document.body.style.overflow = "scroll";
		setIsOpenModal((setShow) => !setShow);
	};

        useEffect(() => {
            const handleResize = () => {
                setImageIsMobile(isMobileHelper());
            };
            handleResize();
            window.addEventListener("resize", handleResize);
            return () => window.removeEventListener("resize", handleResize);
        }, []);


    const updatedMigaDePan = props.migaDePan.replace("Inicio /", "Inicio / Servicio de Empleo /");

    return (
        <div className="o-headboard-sala-prensa" ref={refElement} style={{ marginTop: headerSize.height }}>
            <div className="o-banner-headboard">
                <div className="o-banner-headboard-container">
                    <div className="container">
                    {(props.contentful_id === "3jxj5MrfSas7jg5cm90mBR") && (
                        <Breadcrumb content={updatedMigaDePan} />
                    )}
                    {props.imagenLogo && !sessionStorage.getItem("popup") && (
                        <div
                            className="banner-empresa-headboard-text__logo"
                            style={{
                                display: `${showProtect ? "flex" : "none"}`,
                            }}
                        >
                            <span onClick={handlePopup}>
                                <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="17.536"
                                    height="17.536"
                                    viewBox="0 0 17.536 17.536"
                                >
                                    <g
                                        id="x"
                                        transform="translate(1.768 1.768)"
                                    >
                                        <line
                                            id="Línea_80"
                                            data-name="Línea 80"
                                            x1="14"
                                            y2="14"
                                            transform="translate(0 0)"
                                            fill="none"
                                            stroke="#303030"
                                            strokeLinecap="round"
                                            strokeLinejoin="round"
                                            strokeWidth="2.5"
                                        />
                                        <line
                                            id="Línea_81"
                                            data-name="Línea 81"
                                            x2="14"
                                            y2="14"
                                            transform="translate(0 0)"
                                            fill="none"
                                            stroke="#303030"
                                            strokeLinecap="round"
                                            strokeLinejoin="round"
                                            strokeWidth="2.5"
                                        />
                                    </g>
                                </svg>
                            </span>
                            <div className="headboard-salaprensaMpc-imageFixed">
                                <img
                                    src={props.imagenLogo.file.url}
                                    alt={
                                        props.imagenLogo.description || "Imagen"
                                    }
                                />
                            </div>
                            <div className={props.contentful_id === 
                                        "5DaiDOFY92QDwv5JoOVAy6" ? 
                                        `headboard-salaprensaMpc-text__header__titleEmpresas`
                                        : `headboard-salaprensaMpc-text__header__title`}>
                                <h3>{props.tituloBannerAuxiliar }</h3>
                                <div className={`headboard-salaprensaMpc-text__description ${props.contentful_id === "4WtTrLJzcuELFQgVzNdFhx" ? "o-headboardMpcText" : ""}`}>
                                    {props.descripcionAuxiliarBanner}
                                </div>
                            </div>
                            <div className="headboard-salaprensaMpc-text__descriptionMobile">
                                {props.descripcionAuxiliarBannerMobile}
                            </div>
                            <div className="headboard-salaprensaMpc-text__buttons__itemBanner">
                                {/* Dirige a unete a la comunidad */}
                                {props.contentful_id === 
                                "6Cbz13TpFr7UxQFe8gVaj3" && (
                                    <Button
                                        onClickAction={handleIngresaAction}
                                        type="button"
                                        text={props.tituloSpan}
                                        classname={`a-button__magentaBanner`}
                                        isDisabled={false}
                                    />
                                )}
                                {props.contentful_id ===
                                    "5maRyETSTUfRqS4mdAi8X8" && (
                                        <Button
                                        type="link"
                                        text={props.tituloSpan}
                                        classname={`a-button__magentaBannerMpc gtmConoceElSubsidio`}
                                        isDisabled={false}
                                        href="./mentoria-talento/"
                                    /> 
                                )}
                                {props.contentful_id ===
                                    "5DaiDOFY92QDwv5JoOVAy6" && (
                                        <Button
                                        type="link"
                                        text={props.tituloBotonBanner}
                                        classname={`a-button__bannerEmpresas gtm_encontrar_talento_toast_home_empresas`}
                                        isDisabled={false}
                                        href="./encontrar_talento/"
                                    /> 
                                )}
                            </div>
                        </div>
                    )}
                        <div className="banner-headboard-text">
                            <h1>{props.tituloPrincipal}</h1>
                            <div className="banner-headboard-text__subtitle">
                                {props.descripcion &&
                                    documentToReactComponents(
                                        props.descripcion.json
                                )}
                            </div>
                            <div className="banner-empresa-headboard-text__buttons">
                                {props.tituloBoton && (
                                    <div className="banner-empresa-headboard-text__buttons__item">
                                        {props.contentful_id === 
                                        "5maRyETSTUfRqS4mdAi8X8" && (
                                            <Button
                                                type="link"
                                                text={props.tituloBoton}
                                                classname={
                                                    url.pathname ===
                                                        "/busco-talento/"
                                                        ? `a-button__green`
                                                        : `a-button primary gtmPersonasClicBannerButtonConoceVacantes`
                                                }
                                                href={props.redireccionBoton}
                                                isDisabled={false}
                                            />
                                        )}
                                        {props.contentful_id ===
                                        "5DaiDOFY92QDwv5JoOVAy6" && (
                                            <Button 
                                                onClickAction={() => {
                                                    setIsOpenModal(true)
                                                }}
                                                type="link"
                                                text={props.tituloBoton}
                                                classname={`a-button__white gtm_solicitar_servicios_empresas_banner`}
                                                isDisabled={false}
                                            />
                                        )}
                                    </div>
                                    
                                )}
                            </div>
                        </div>
                    </div>
                    {props.imagenHeader && (
                        <img
                            className="banner-headboard-image"
                            src={isImageMobile
                                ? `${props.imagenMobile.file.url}`
                                : `${props.imagenHeader.file.url}`}
                            alt={
                                props.imagenHeader.description ||
                                "imagen cabecera sala de prensa"
                            }
                            loading="lazy"
                        />
                    )}
                </div>
            </div>
            {isOpenModal && (
                <ModalSolicitudServicios showModal={isOpenModal} onClose={closeModal}/>
            )}
            {isMobile() && (<>
                <span className={`o-headboard-sala-prensa__arrow icon-chevron-left`} onClick={() => moveUlMenu("L")}></span>
                <span className={`o-headboard-sala-prensa__arrow icon-chevron-right active`} onClick={() => moveUlMenu("R")}></span>
            </>)
            }
        </div>
    );
};

export default HeadboardSalaPrensa;
